var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBottomQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8h10.2V34H0v10.4h4.2c11.4 0 16.4-4.2 16.4-15.2V0H0v16.8zm29 0h10.2V34H29v10.4h4.2c11.4 0 16.4-4.2 16.4-15.2V0H29v16.8z",
    fill: "url(#bottomQuotes_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottomQuotes_svg__paint0_linear",
    x1: 27.142,
    y1: 41.532,
    x2: 0.883,
    y2: 23.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BD7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468FBD"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTAgNDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDE2LjhIMTAuMlYzNEgwVjQ0LjRINC4yQzE1LjYgNDQuNCAyMC42IDQwLjIgMjAuNiAyOS4yVjBIMFYxNi44Wk0yOSAxNi44SDM5LjJWMzRIMjlWNDQuNEgzMy4yQzQ0LjYgNDQuNCA0OS42IDQwLjIgNDkuNiAyOS4yVjBIMjlWMTYuOFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjI3LjE0MjIiIHkxPSI0MS41MzI1IiB4Mj0iMC44ODI5NzEiIHkyPSIyMy4yNTk3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2QkQ3QjQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDY4RkJEIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgBottomQuotes as ReactComponent };